// extracted by mini-css-extract-plugin
export default {"content":"ArticleContent_content__4e65T"};